var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemortgaging(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.0002,
    r: 30,
    fill: "#EDF1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1984 26.3518C42.743 24.6481 45.3297 23.9565 45.7852 25.6602C46.9278 29.9271 46.2324 34.2537 44.1843 37.8029L44.1816 37.8016C39.6942 45.5727 29.7314 48.1072 22.0942 43.5128L21.017 45.3802C20.8738 45.6284 20.5015 45.5916 20.4102 45.3201L18.643 40.1122C18.5762 39.9144 18.7002 39.707 18.9061 39.673L24.1724 38.8191C24.4519 38.774 24.6578 39.0728 24.516 39.3169L23.4306 41.1993C26.515 43.0654 30.224 43.6233 33.7815 42.6698C40.8968 40.7628 45.102 33.4584 43.1984 26.3518ZM17.4673 33.2513C15.5638 26.1444 19.7677 18.8398 26.8845 16.9332C30.442 15.9797 34.1509 16.5376 37.2354 18.4036L36.15 20.286C36.0082 20.5315 36.2141 20.8303 36.4936 20.7839L41.7598 19.93C41.9657 19.8973 42.0898 19.6886 42.023 19.4908L40.2558 14.2828C40.1631 14.0114 39.7922 13.9745 39.649 14.2228L38.5718 16.0902C30.9342 11.4947 20.9718 14.0305 16.4844 21.8014L16.4817 21.8C14.4335 25.3479 13.7395 29.6762 14.8822 33.9417C15.3376 35.6454 17.9228 34.9536 17.4673 33.2513Z",
    fill: "#00456C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemortgaging);
export default __webpack_public_path__ + "static/media/remortgaging.47fb6975f81060a29fd20ca88afb0ef1.svg";
export { ForwardRef as ReactComponent };